import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {MatButton, MatFabButton, MatIconButton, MatMiniFabButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-button',
  imports: [
    MatButton,
    MatMiniFabButton,
    MatIcon,
    MatIconButton,
    MatFabButton,
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent implements OnInit {
  @Input() isBack: boolean = false;
  @Input() label: string = 'Button';
  @Input() disabled: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset'  = 'button';
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() format: 'default' | 'icon' | 'fab' | 'mini-fab' | 'flat' | 'basic'  = 'default';
  @Input() extraClass: string = '';
  @Input() icon: string = '';
  @Input() hasWhiteText: boolean = false;
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  extraColorClass = "";

  onClick(event: Event): void {
    this.buttonClick.emit();
  }

  ngOnInit() {
    if(this.hasWhiteText) {
      this.extraColorClass = 'whiteText';
    }
  }
}
